import { Injectable } from '@angular/core'
import { EventService, GlobalMessageService } from '@spartacus/core'
import { UserAccountEventListener } from '@spartacus/user/account/root'

@Injectable({
  providedIn: 'root',
})
export class MbUserAccountEventListener extends UserAccountEventListener {

  constructor (protected eventService: EventService,
              protected globalMessageService: GlobalMessageService) {
    super(eventService, globalMessageService)
  }

  protected onAuth () { }
}
